import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
Vue.config.devtools = true;

export default new Vuex.Store({
    state: {
        logedInUser: null,
        socials: null,
        cart_products: {
            tailoring_products: [],
            dry_clean_products: [],
            wash_products: [],
            timing: [],
            dates:[],
        },
    },
    mutations: {

        LOGEDIN(state, payload) {
            state.logedInUser=payload;
        },
        LOGOUT(state, payload) {
            state.logedInUser = payload; 
        },

        //** setting single item in cart */ /
        SETWASH(state, payload) {
            const index = state.cart_products.wash_products.findIndex(it => it.id === payload.id);
            if (index === -1) {
                
                state.cart_products.wash_products.push(payload);
            } else {
                state.cart_products.wash_products[index] = payload;
            }
            const products =  state.cart_products.wash_products;
            localStorage.setItem(
                "wash_products",
                JSON.stringify(products)
            );
        },
        SETDRY(state, payload) {
            const index = state.cart_products.dry_clean_products.findIndex(it => it.id === payload.id);
            if (index === -1) {
                state.cart_products.dry_clean_products.push(payload);
            } else {
                //console.log("state.cart_products.dry_clean_products[index] ",state.cart_products.dry_clean_products[index] );
                state.cart_products.dry_clean_products[index] = payload;
            }
            const products =  state.cart_products.dry_clean_products;
            localStorage.setItem(
                "dry_clean_products",
                JSON.stringify(products)
            );
        },
        SETTAILORING(state, payload) {
            // state.cart_products.tailoring_products.push(payload);
            const index = state.cart_products.tailoring_products.findIndex(it => it.id === payload.id);
            if (index === -1) {
                state.cart_products.tailoring_products.push(payload);
            } else {
                state.cart_products.tailoring_products[index] = payload;
            }
            const products =  state.cart_products.tailoring_products;
            localStorage.setItem(
                "tailoring_products",
                JSON.stringify(products)
            );
        },
        /* so set if its get from localstorage*/
        SET_ALL_WASH(state, payload) {
            if (payload) {
                state.cart_products.wash_products = payload;
                /** removing default product if more then one item */
                const products = state.cart_products.wash_products;
                if (products.length > 1) {
                    const index = products.findIndex(it => it.id == '10001');
                    if (index != -1) {
                        products.splice(index, 1);
                        localStorage.setItem(
                            "wash_products",
                            JSON.stringify(products)
                        );
                    }
                }
            }
        },
        SET_ALL_DRY(state, payload) {
            if (payload) {
                state.cart_products.dry_clean_products = payload;
                /** removing default product if more then one item */
                const products = state.cart_products.dry_clean_products;
                if (products.length > 1) {
                    const index = products.findIndex(it => it.id == '20001');
                    if (index != -1) {
                        products.splice(index, 1);
                        localStorage.setItem(
                            "dry_clean_products",
                            JSON.stringify(products)
                        );
                    }
                }
            }

        },
        SET_ALL_TAILORING(state, payload) {
            if (payload) {
                state.cart_products.tailoring_products = payload;
                /** removing default product if more then one item */
                const products = state.cart_products.tailoring_products;
                if (products.length > 1) {
                    const index = products.findIndex(it => it.id == '30001');
                    if (index != -1) {
                        products.splice(index, 1);
                        localStorage.setItem(
                            "tailoring_products",
                            JSON.stringify(products)
                        );
                    }
                }
            }
        },

        /* in case of removing item from cart. removing it from vuex and updating local storage*/

        REMOVE_WASH_ITEM(state, payload) {
            if (state.cart_products.wash_products) {
                const index = state.cart_products.wash_products.findIndex(it => it.id === payload.id);
                if (index != -1) {
                    const products = state.cart_products.wash_products;
                    products.splice(index, 1);
                    localStorage.setItem(
                        "wash_products",
                        JSON.stringify(products)
                    );
                }
            }
        },
        REMOVE_DRY_ITEM(state, payload) {
            //console.log("in commit REMOVE_DRY_ITEM - Dry Clean", payload);

            if (state.cart_products.dry_clean_products) {
                const index = state.cart_products.dry_clean_products.findIndex(it => it.id === payload.id);
                //console.log("index", index);
                if (index != -1) {
                    const products = state.cart_products.dry_clean_products;
                    //console.log("before - updated dry clean products",products)
                    products.splice(index, 1);
                    //console.log("after - updated dry clean products",products)
                    
                    localStorage.setItem(
                        "dry_clean_products",
                        JSON.stringify(products)
                    );
                }
            }
        },
        REMOVE_TAILORING_ITEM(state, payload) {

            if (state.cart_products.tailoring_products) {
                const index = state.cart_products.tailoring_products.findIndex(it => it.id === payload.id);
                if (index != -1) {
                    const products = state.cart_products.tailoring_products;
                    products.splice(index, 1);
                    localStorage.setItem(
                        "tailoring_products",
                        JSON.stringify(products)
                    );
                }
            }
        },

        SET_ORDER_TIMING(state, payload) {
            const index = state.cart_products.timing.findIndex(it => it.id === payload.id);
            if (index === -1) {
                if (payload.type == 'pickup') {
                    localStorage.setItem('pickup_timing_'+payload.category, JSON.stringify(payload))
                } else {
                    localStorage.setItem('delivery_timing_'+payload.category, JSON.stringify(payload))
                }
            } else {
                state.cart_products.timing[index] = payload;
                if (payload.type == 'pickup') {
                    localStorage.setItem('pickup_timing_'+payload.category, JSON.stringify(payload))
                } else {
                    localStorage.setItem('delivery_timing_'+payload.category, JSON.stringify(payload))
                }
            }
        },
        SET_ORDER_DATE(state, payload){
            const index = state.cart_products.dates.findIndex(it => it.date === payload.date);
            if (index === -1) {
                if (payload.type == 'pickup') {
                    localStorage.setItem('pickup_date_'+payload.category, JSON.stringify(payload.formated_date))
                } else {
                    localStorage.setItem('delivery_date_'+payload.category, JSON.stringify(payload.formated_date))
                }
            } else {
                state.cart_products.dates[index] = payload;
                if (payload.type == 'pickup') {
                    localStorage.setItem('pickup_date_'+payload.category, JSON.stringify(payload.formated_date))
                } else {
                    localStorage.setItem('delivery_date_'+payload.category, JSON.stringify(payload.formated_date))
                }
            }
        },
        REMOVE_ALL_WASH(state,payload){
            state.cart_products.wash_products=[];
            localStorage.setItem('wash_products', JSON.stringify([]))
        },
        REMOVE_ALL_DRY(state,payload){
            state.cart_products.dry_clean_products=[];
            localStorage.setItem('dry_clean_products', JSON.stringify([]))
        },
        REMOVE_ALL_TAILORING(state,payload){
            state.cart_products.tailoring_products=[];
            localStorage.setItem('tailoring_products', JSON.stringify([]))
        }
    },
    actions: {

        islogedIn({ commit }, payload) {
            commit('LOGEDIN', payload)
        },
        islogut({ commit }, payload) {
            commit('LOGOUT', payload)
        },
        
        setCart({ commit }, payload) {
            if (payload.type == 'wash') {
                // delete payload.type;
                commit('SETWASH', payload)
            } else if (payload.type == 'dry_clean') {
                // delete payload.type;
                commit('SETDRY', payload)
            } else if (payload.type == 'tailoring') {
                // delete payload.type;
                commit('SETTAILORING', payload)
            }
        },
        setALLWASH({ commit }, payload) {
            commit('SET_ALL_WASH', payload)
        },
        setALLDRY({ commit }, payload) {
            commit('SET_ALL_DRY', payload)
        },
        setALLTAILOR({ commit }, payload) {
            commit('SET_ALL_TAILORING', payload)
        },


        removeItem({ commit }, payload) {
            if (payload.type == 'wash') {
                commit('REMOVE_WASH_ITEM', payload)
            } else if (payload.type == 'dry_clean') {
                ////console.log("in commit removeItem - Dry Clean");
                commit('REMOVE_DRY_ITEM', payload)
            } else if (payload.type == 'tailoring') {
                ////console.log('in commit remove item - in tailoring')
                commit('REMOVE_TAILORING_ITEM', payload)
            }
        },
        removeAllWash({ commit }, payload){
            commit('REMOVE_ALL_WASH', payload)
        },
        removeAllDry({ commit }, payload){
            commit('REMOVE_ALL_DRY', payload)
        },
        removeAllTailoring({ commit }, payload){
            commit('REMOVE_ALL_TAILORING', payload)
        },

        setOrderTiming({ commit }, payload) {
            commit('SET_ORDER_TIMING', payload)
        },
        setOrderDate({commit}, payload){
            commit('SET_ORDER_DATE', payload)
        }

    }
});


// WEBPACK FOOTER //
// ./src/store.js